import React, { ReactElement, ReactNode } from 'react';
import { GetSchoolResponse } from 'services/api';
import { ForYouShell } from '../../ForYouShell';
import { ForYouTabKey } from '../SubNav';
import { useBrowseSidebar } from '../../useBrowseSidebar';
import { EventsBrowse } from './EventsBrowse';

export interface EventsPageProps {
  slug: string | null;
  school?: GetSchoolResponse;
  tabs?: ForYouTabKey[];
  topBanner?: ReactNode;
}

export const EventsPage = ({
  slug,
  school,
  tabs,
  topBanner,
}: EventsPageProps): ReactElement => {
  const { banner, desktopSidebar, mobileBefore, mobileAfter } =
    useBrowseSidebar(school);

  return (
    <ForYouShell
      activeTab="events"
      documentTitle="CampusLush | Events"
      desktopSidebar={desktopSidebar}
      mobileBanner={banner}
      bleedMobileBanner
      mobileBefore={mobileBefore}
      mobileAfter={mobileAfter}
      tabs={tabs}
      topBanner={topBanner}
    >
      <EventsBrowse slug={slug} />
    </ForYouShell>
  );
};
